import { createSelector } from 'reselect';

import { VERTICAL_GENDER } from '@conversion/constants';
import { getShopVertical } from '@conversion/selectors';

export const getIsClosed = createSelector(
  getShopVertical,
  vertical =>
    vertical?.gender === VERTICAL_GENDER.MALE ? 'cerrado' : 'cerrada',
);
